__turbopack_context__.v({
  "benefitList": "JP_5Aa_benefitList",
  "features": "JP_5Aa_features",
  "infoIcon": "JP_5Aa_infoIcon",
  "listItem": "JP_5Aa_listItem",
  "productPage": "JP_5Aa_productPage",
  "productPageCalculator": "JP_5Aa_productPageCalculator",
  "productStage": "JP_5Aa_productStage",
  "stageAwards": "JP_5Aa_stageAwards",
});
